
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useRef, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { Link, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";

export default function FormSticker() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [detail, setDetail] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [imagePreviews, setImagePreviews] = useState([]);
    const fileInputRef = useRef(null);

    const defaultdetail = {
        company_id: '', author_id: user.data.id, shortname: '', title: '', status: 1,
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "posts_sticker/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                let detail = res.data.data
                                if (detail.url && Array.isArray(detail.url)) {
                                    setImagePreviews(detail.url)
                                }
                                setDetail(detail);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, refresh]
    );
    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Nhập tên sticker').max(150, "Độ dài không quá 150 ký tự")
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setLoading(true)
            values.url = imagePreviews
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'posts_sticker/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật Sticker thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                // console.log(values);
                Axios.post(URL_LIST_ALL + 'posts_sticker', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới Sticker thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const convertImageToBlobAfterResize = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const img = new Image();
                img.src = reader.result;
                img.onload = () => {
                    const maxSize = 300;
                    const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;

                    const ctx = canvas.getContext("2d");

                    // Nếu ảnh PNG có nền trong suốt, cần clear canvas
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    // Giữ định dạng ban đầu
                    const outputType = file.type === "image/png" ? "image/png" : "image/jpeg";

                    canvas.toBlob((blob) => {
                        if (blob) {
                            resolve(blob);
                        } else {
                            reject(new Error("Không thể chuyển đổi ảnh"));
                        }
                    }, outputType, 0.9);
                };
                img.onerror = reject;
            };
            reader.onerror = reject;
        });
    };


    const handleMultiImageUpload = async (e) => {
        const files = e.target.files;
        if (!files) return;

        const uploadPromises = [...files].map(async file => {
            const formData = new FormData();
            const resizedBlob = await convertImageToBlobAfterResize(file);

            formData.append('file', resizedBlob, file.name);
            formData.append('changename', 1);
            formData.append('folder', 0);

            setUploading(true);
            return Axios.post(URL_LIST_ALL + 'fileupload', formData, user.config).then(res => {
                if (res.data.status === 'success') {
                    return res.data.message;
                } else {
                    confirmAlert({
                        title: 'Lỗi',
                        message: res.data.message,
                        buttons: [{ label: 'OK' }]
                    });
                    return null;
                }
            }).catch(err => {
                console.error(err);
                return null;
            });
        });

        const uploadedImages = await Promise.all(uploadPromises);
        const filteredImages = uploadedImages.filter(url => url !== null);
        setImagePreviews(prev => [...prev, ...filteredImages]);
        setUploading(false);
    };

    const handleRemoveImage = (index) => {
        confirmAlert({
            title: 'Xác nhận',
            message: 'Bạn có chắc muốn xóa ảnh này?',
            buttons: [
                {
                    label: 'Có',
                    onClick: () => {
                        const updated = [...imagePreviews];
                        updated.splice(index, 1);
                        setImagePreviews(updated);
                    }
                },
                {
                    label: 'Không'
                }
            ]
        });
    };

    return (
        <AkkhorLayout idrole="quan-ly-sticker">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/quan-ly-sticker">Quản lý Sticker</Link>
                    </li>
                    <li>{id ? 'Sửa Sticker' : 'Thêm mới Sticker'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Phòng ban</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 col-sm-6 form-group">
                                <label>Tên Sticker <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                            <div className="col-12"></div>
                            <div className="col-12 col-sm-6 form-group">
                                <label>Hình ảnh</label>
                                <button type="button" className="btn btn-upload-image btn-outline-info" onClick={() => fileInputRef.current.click()}>
                                    <span className='fas fa-camera-retro'></span>
                                </button>
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    multiple={true}
                                    onChange={handleMultiImageUpload}
                                />

                                {uploading && <Spinner />}

                                {imagePreviews.length > 0 && (
                                    <div className="mt-3 d-flex flex-wrap gap-2">
                                        {imagePreviews.map((src, index) => (
                                            <div key={index} style={{ position: 'relative' }}>
                                                <img
                                                    src={src}
                                                    alt={`preview-${index}`}
                                                    style={{
                                                        width: 100,
                                                        height: 100,
                                                        objectFit: 'cover',
                                                        borderRadius: 8
                                                    }}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger"
                                                    style={{
                                                        position: 'absolute',
                                                        top: 2,
                                                        right: 2,
                                                        padding: '2px 6px',
                                                        fontSize: 10,
                                                        borderRadius: '50%'
                                                    }}
                                                    onClick={() => handleRemoveImage(index)}
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="col-12"></div>
                            <div className="col-lg-6 col-12 form-group">
                                <label>Trạng thái</label>
                                <select className="form-select height32" {...formik.getFieldProps("status")}>
                                    <option value="0">Không hoạt động</option>
                                    <option value="1">Hoạt động</option>
                                </select>
                            </div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
